export var paginationTypes=["pages","loadMore"];